import { render, staticRenderFns } from "./HelperIncentivos.vue?vue&type=template&id=24dd4762&lang=pug"
import script from "./HelperIncentivos.vue?vue&type=script&lang=js"
export * from "./HelperIncentivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports